import { MS_PER_HOUR } from '../constants.js';

export const MOCK_DATA = {
  children: [
    // Emma's weight is overdue for a check; Liam's predates weightUpdatedAt.
    { id: 'mock-child-1', name: 'Emma', dob: '2021-03-15', weight: 14.2, weightUpdatedAt: new Date(Date.now() - 100 * 86400000).toISOString() },
    { id: 'mock-child-2', name: 'Liam', dob: '2019-08-02', weight: 19.5 },
  ],
  // Newest-first — the DEV_MODE loader hands this straight to setDosageHistory
  // without the sort that real synced data goes through, and the safety checks
  // rely on find() returning the most recent matching dose.
  history: [
    // Recent ibuprofen for a child with no paracetamol on record: exercises the
    // cross-med path, where crossMedIntervalHours alone gates the other tab.
    {
      id: 'mock-h4', timestamp: new Date(Date.now() - 0.5 * MS_PER_HOUR).toISOString(),
      medication: 'ibuprofen', dose: '6.0', mgTotal: '195', weight: 19.5,
      concentration: '100 mg/5 ml', childName: 'Liam', childId: 'mock-child-2', loggedBy: 'Test phone',
    },
    {
      id: 'mock-h1', timestamp: new Date(Date.now() - 2 * MS_PER_HOUR).toISOString(),
      medication: 'paracetamol', dose: '5.0', mgTotal: '213', weight: 14.2,
      concentration: '120 mg/5 ml', childName: 'Emma', childId: 'mock-child-1', loggedBy: 'Test phone',
    },
    {
      id: 'mock-h2', timestamp: new Date(Date.now() - 9 * MS_PER_HOUR).toISOString(),
      medication: 'ibuprofen', dose: '6.0', mgTotal: '195', weight: 19.5,
      concentration: '100 mg/5 ml', childName: 'Liam', childId: 'mock-child-2', loggedBy: 'Test phone',
    },
    {
      id: 'mock-h3', timestamp: new Date(Date.now() - 26 * MS_PER_HOUR).toISOString(),
      medication: 'other', medicationType: 'Antibiotics', medicationName: 'Amoxicillin 250mg',
      weight: 14.2, childName: 'Emma', childId: 'mock-child-1',
    },
  ],
  temperatures: [
    // t1 carries a device stamp, t2 doesn't — readings logged before the stamp
    // existed still have to render, so keep one of each.
    { id: 'mock-t1', timestamp: new Date(Date.now() - 3 * MS_PER_HOUR).toISOString(), tempC: 38.4, childId: 'mock-child-1', childName: 'Emma', loggedBy: 'Test phone' },
    { id: 'mock-t2', timestamp: new Date(Date.now() - 30 * MS_PER_HOUR).toISOString(), tempC: 37.1, childId: 'mock-child-2', childName: 'Liam' },
  ],
  concentrations: { paracetamol: [], ibuprofen: [] },
  otherMeds: [
    { name: 'Antibiotics', category: 'Antibiotics' },
    { name: 'Antihistamine', category: 'Allergy' },
  ],
};
